const ToastStyles = theme => ({
  '.toast': {
    padding: '0',
    background: theme.palette.background.paper,
    color: 'inherit',
    minHeight: 'inherit',
    borderRadius: theme.border.radius,

    '.feedback': {
      margin: 0,
    },
  },
  '.Toastify__toast-container': {
    zIndex: 2147483647,
    width: 'max-content',
    borderRadius: theme.border.radius,
  },
  '.Toastify__toast-container--top-center': {
    left: 'unset',
    marginLeft: 0,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
});

export default ToastStyles;
